import styled from 'styled-components';
import { Styling } from '../../../constants';
import { Separator } from '..';

export const SeparatorOverride = styled(Separator)`
  margin-top: ${Styling.DEFAULT_SPACING_HALVED}px;
  margin-bottom: ${Styling.DEFAULT_SPACING_HALVED}px;
`;
